<template>
  <div ref="searchBox" :class="['comp-search', className]" @keydown.stop>
    <div id="search-box" ref="search-box">
      <input
        class="search"
        type="text"
        placeholder="搜索关键词"
        autocomplete="off"
        maxlength="50"
        :value="$util.emojiFilter(value)"
        @input.stop="$emit('input', $event.target.value)"
        @focus.stop="inputFocus"
        @blur.stop="inputBlur"
        @keyup.enter.stop="searchClick(value)"
        @click.stop="track"
        @paste.stop
      />

      <!-- 取消搜索按钮 -->
      <transition name="cancelBtn-fade">
        <i v-if="value" class="cancel" @click="cancelClick"></i>
      </transition>

      <!-- 确认搜索按钮 -->
      <button
        v-analysis="ANALYSIS.search"
        class="submit"
        @click="searchClick(value)"
      >
        <!-- <i class="search_icon"></i> -->
      </button>

      <!-- 下拉框 -->
      <div
        ref="dropdownBox"
        :class="['history-box', { 'history-active': isShowHistory }]"
        :style="[{ top: '42px', display: 'none' }]"
      >
        <!-- 热门搜索 -->
        <div v-if="isHotCates" class="type hot">
          <p class="title">热门搜索</p>
          <ul class="list">
            <li
              v-for="(hot, index) in hotCates"
              :key="index"
              class="item"
              @click="historyClick($event, hot)"
            >
              {{ hot.name }}
            </li>
          </ul>
        </div>
        <!-- 历史搜索 -->
        <div v-if="searchHistory.length > 0" class="type history">
          <p class="title">历史搜索</p>
          <ul class="list">
            <li
              v-for="(item, index) in searchHistory"
              :key="index"
              class="item"
              @click="historyClick($event, item)"
            >
              {{ item }}
            </li>
          </ul>
        </div>
      </div>

      <!-- 自动轮播热门搜索标签 !focusing &&carouselVisible-->
      <div v-if="true" ref="ref1" :style="hotcatesboxStyle">
        <ul class="hotcates-list" :style="[hotCatesStyle]" ref="hotcates-list">
          <li
            v-for="(hot, index) in hotCates"
            :key="index"
            class="hotcates-item"
            @click="historyClick($event, hot)"
          >
            <span class="hotcate">{{ hot.name }}</span>
          </li>
        </ul>
      </div>
      <div class="hotcates-title" :style="hotcatestitleStyle">热门搜索：</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "LhSearch",
  props: {
    className: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    isHotCates: {
      type: Boolean,
      default: true,
    },
    hotCates: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      default: "",
    },
    // 是否显示热门标签的轮播列表
    carouselVisible: {
      type: Boolean,
      defautl: false,
    },
  },
  data() {
    return {
      ANALYSIS: {
        search: {
          category: "template",
          action: "click_template_search",
          label: "模板_搜索",
        },
      },
      searchHistory: [], // 搜索历史
      isShowHistory: 0, // 历史框状态
      currentHistory: -1, // flag: 键盘方向键选择搜索记录
      searchBoxHeight: 0, //搜索框高度
      focusing: false,
      activeIndex: 0,
      hotcatesboxStyle: {
        position: "absolute",
        width: "200px",
        height: "100%",
        left: "-220px",
        overflow: "hidden",
      },
      hotcatestitleStyle: {
        left: "-281px",
      },
    };
  },
  computed: {
    hotCatesStyle() {
      return {
        transform: `translate(0, ${-35 * this.activeIndex}px)`,
        "transition-property": "transform",
        "transition-duration": "1s",
        "transition-timing-function": "ease-in-out",
        // "transition": "transform .1s ease-in-out",
      };
    },
  },
  watch: {
    value(nv) {
      if (nv) {
        this.isShowHistory = 0;
      }
    },
    hotCates(nv) {
      // console.log(`nv:`,nv);
    },
  },
  mounted() {
    this.getBoxHeight();
    document.addEventListener("click", this.blankClick);
    this.init();
  },
  beforeDestroy() {
    document.removeEventListener("click", this.blankClick);
  },
  methods: {
    track() {
      sensors.track("searchClick", {
        search_source: "编辑器素材弹窗",
      });
    },
    init() {
      if (!this.carouselVisible) return;
      let this_ = this;

      setTimeout(() => {
        if (!this_.$refs["hotcates-list"]) return;
        let height = this_.$refs["hotcates-list"].offsetHeight;
        let length = height / 35;
        let timer;
        this.activeIndex = 0;
        // timer = setInterval(() => {
        //   if (height < 3) {
        //     if (!this_.$refs["hotcates-list"]) return;
        //     //在组件的缓存情况下，height为0，需要重新获取
        //     height = this_.$refs["hotcates-list"].offsetHeight;
        //     //console.log("TCL: timer -> this_.$refs['hotcates-list']", this_.$refs['hotcates-list'])
        //     length = height / 35;
        //   }
        //   if (this.activeIndex >= length - 1) {
        //     this.activeIndex = 0;
        //   } else {
        //     this.activeIndex++;
        //   }
        // }, 3000);
      }, 1000);
    },
    getBoxHeight() {
      this.searchBoxHeight = this.$refs["search-box"].offsetHeight;
    },
    inputFocus(e) {
      this.focusing = true;
      this.isShowHistory = 1;
      this.searchHistory = [];
      this.getKeywords();
    },
    inputBlur(e) {
      this.focusing = false;
    },
    searchClick(keyword) {
      keyword = this.$util.delSpacesOfStr(keyword);
      this.isShowHistory = 0;
      this.searchHistory = [];
      this.setKeywords(keyword);
      this.$emit("searchClick", keyword);
      this.$bus.emit("bus::searchClick", keyword);
    },
    historyClick(e, item) {
      this.$store.commit("tracking/setTrackingData", {
        keyword_type: "热门推荐词",
      });
      this.$emit("input", e.currentTarget.innerText);
      this.$emit("historyClick", e);
      this.$bus.emit("bus::historyClick", e.currentTarget.innerText);
    },
    blankClick(e) {
      if (
        this.isShowHistory &&
        this.$refs.searchBox !== undefined &&
        !this.$refs.searchBox.contains(e.target)
      ) {
        this.isShowHistory = 0;
      }
    },
    cancelClick() {
      // 通过组件自定义事件实现在组件中改变props的值
      this.$emit("input", "");
      this.$emit("cancelClick");
      this.$bus.emit("bus::searchCancelClick");
    },
    /*
     * 方向键选择历史记录
     */
    keyTap(e) {
      // console.log(e.keyCode);
      const historyList = document.querySelectorAll(".history li"),
        historyNum = historyList.length;

      switch (e.keyCode) {
        case 38: //向上
          this.currentHistory--;
          if (this.currentHistory > -1) {
            this.$emit("input", historyList[this.currentHistory + 1].innerText);
          } else {
            this.currentHistory = historyNum - 2;
            this.$emit("input", historyList[this.currentHistory + 1].innerText);
          }
          break;
        case 40: //向下
          this.currentHistory++;
          if (this.currentHistory < historyNum - 1) {
            this.$emit("input", historyList[this.currentHistory + 1].innerText);
          } else {
            this.currentHistory = 0;
            this.$emit("input", historyList[this.currentHistory + 1].innerText);
          }
          break;
        case 27: //esc
          this.$emit("input", "");
          this.isShowHistory = 0;
          document.querySelector("#search-box input").blur(); //input主动失去焦点
          break;
        default:
          return;
          break;
      }
      // console.log(this.currentHistory);
    },
    inputKeyDown(e) {
      //修复删除键失效的问题
      //value =
      // this.$emit("input", this.value.slice(0, this.value.length - 1));
    },
    /*获取搜索记录*/
    getKeywords() {
      let keywords = localStorage[this.name];
      // console.log(keywords)
      if (keywords) {
        keywords = JSON.parse(keywords);

        if (keywords.length) {
          // 翻转数组，最近搜索在前面
          keywords.reverse().forEach((i) => {
            this.searchHistory.push(i);
          });
        }
      } else {
        this.isShowHistory = 0;
        localStorage[this.name] = JSON.stringify([]);
      }
    },
    /*存储搜索记录*/
    setKeywords(keyword) {
      if (keyword == "") {
        console.log("不能为空");
        return;
      }
      let keywords = localStorage[this.name];
      if (!keywords) {
        localStorage[this.name] = JSON.stringify([]);
      } else {
        keywords = JSON.parse(keywords);

        // 控制存储搜索记录数量:5条
        if (keywords.length >= 5) {
          keywords.reverse().length = 4;
          keywords.reverse();
          // keywords.splice(0,1)
          keywords.push(keyword);
          // 去掉重复值
          keywords = [...new Set(keywords)];
          localStorage[this.name] = JSON.stringify(keywords);
        } else {
          keywords.push(keyword);
          keywords = [...new Set(keywords)];
          localStorage[this.name] = JSON.stringify(keywords);
        }
      }
    },
    mouseEnter(e, idx) {
      this.currentHistory = idx;
    },
  },
};
</script>
<style lang="scss" scoped>
.comp-search {
  width: 100%;
  height: 100%;
  border-radius: 16px;
  #search-box {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border: 1px solid #d4d4e7;
    border-radius: 16px;
    position: relative;
    display: flex;
    align-items: center;
    background-color: #fff;
  }

  .search {
    flex: 1;
    border: none;
    // height: 100%;
    border-radius: 4px;
    font-size: 15px;
    color: #666;
    margin: 0 12px 0 11px;
  }
  ::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    font-size: 12px;
    color: #aca8c4;
  }
  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #aca8c4;
  }
  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #aca8c4;
  }
  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #aca8c4;
  }
  // 去掉获取焦点时的自带边框
  .search:focus {
    outline: none;
  }

  i.cancel {
    right: 25px;
    position: absolute;
    width: 20px;
    height: 20px;
    background: url(../../../../../../static/svg/template-material-lib/common/clear-btn.svg)
      center no-repeat;
    //background-position: -10px -1237px;
    transform: scale(0.66);
    padding: 0 5px;
    font-style: normal;
    display: inline-block;
    cursor: pointer;
  }

  .submit {
    position: absolute;
    right: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: solid 0 transparent;
    outline: none; //取消焦点样式
    width: 14px;
    height: 14px;
    background: url("../../../../../../static/svg/template-material-lib/common/search.svg")
      center no-repeat;
    cursor: pointer;
    // &:hover {
    //   //background-color: #bebed6;
    // }
    // .search_icon {
    //   justify-content: center;
    //   width: 100%;
    //   height: 100%;
    // }
  }

  .history-box {
    box-sizing: border-box;
    background: #fff;
    width: inherit;
    position: absolute;
    top: 45px;
    overflow: hidden;
    transition: all 0.5s linear;
    z-index: 1;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    font-size: 12px;
    height: 0;
    z-index: 233;
    .type {
      padding: 17px 20px;
      width: 100%;
      box-sizing: border-box;
      .title {
        color: #0a293f;
        text-align: left;
      }
      .list {
        color: #67767d;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        .item {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: left;
          padding: 5px 15px 5px 0;
          cursor: pointer;
          &:hover {
            color: #0a293f;
          }
        }
      }
    }
  }
  .history-active {
    display: table;
    // min-height: 230px;
    transition: all 0.3s linear;
  }

  .cancelBtn-fade-enter-active {
    transition: all 0.2s ease;
  }
  .cancelBtn-fade-leave-active {
    transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .cancelBtn-fade-enter, .cancelBtn-fade-leave-to
    /* .cancelBtn-fade-leave-active for below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
  }

  .hotcates-title {
    position: absolute;
    color: #474261;
    left: -281px;
  }
  .hotcates-box {
    position: absolute;
    //width: 200px;
    height: 100%;
    //left: -220px;
    overflow: hidden;
  }
  .hotcates-list {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-content: space-around;
    justify-content: flex-start; //flex-end：从右开始填充
  }
  .hotcates-item {
    height: 34px;
    line-height: 33px;
  }
  .hotcate {
    padding: 0 0 0 0;
    margin: 0px 10px;

    background-color: transparent;
    color: #474261;
    border-radius: 12px;
    cursor: pointer;
  }
}
.templates-search-class {
  #search-box {
    border: solid 1px #d4d4e7;
  }
  .submit {
    border-width: 0px;
    //background-image: linear-gradient(105deg, #648eff 0%, #76a3ff 100%);
  }
  .search {
    font-size: 12px;
    ::-webkit-input-placeholder {
      color: #aca8c4;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/templateLib/contents/common/search.vue